import { type EmployersEmployee } from 'utils/web_api.schemas'

interface StatusBadgeProps {
  employee: EmployersEmployee
}

export const StatusBadge = ({ employee }: StatusBadgeProps) => {
  if (employee.member_id) {
    return (
      <span className='inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800'>
        Signed up
      </span>
    )
  }

  if (employee.last_invited_at) {
    return (
      <span className='inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800'>
        Invited
      </span>
    )
  }

  return (
    <span className='inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800'>
      Not invited
    </span>
  )
}
